import styles from './styles.module.css';

export const InfoBox = ({ message }) => (
      <div className={styles.preview}>
        <div className={styles['preview-image-box']}>
          <span className={styles['preview-image-name']}>{message}</span>
        </div>
      </div>
);
